import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/image/logo.png';
const _hoisted_1 = {
  title: "全屏/正常",
  class: "menu-item"
};
import { ref } from "vue";
import { Menu, Dropdown, Fullscreen } from "@/components/layout";
export default {
  __name: 'Topbar',
  setup(__props) {
    const userInfo = ref();
    const setUserInfo = () => userInfo.value.showClick();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "menu-header"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "logo white",
        style: {
          "width": "160px"
        }
      })], -1)), _createVNode(_unref(Menu)), _createElementVNode("div", null, [_createElementVNode("ul", {
        class: "menu-box",
        style: _normalizeStyle({
          '--text-color': _ctx.$store.state.BackgroundStatus.TextColor,
          '--hover-color': _ctx.$store.state.BackgroundStatus.HoverColor
        })
      }, [_createElementVNode("li", _hoisted_1, [_createVNode(_unref(Fullscreen))]), _createElementVNode("li", {
        class: "menu-item mr10",
        onClick: setUserInfo
      }, [_createVNode(_unref(Dropdown), {
        ref_key: "userInfo",
        ref: userInfo
      }, null, 512)])], 4)])], 64);
    };
  }
};